module.exports = __webpack_public_path__ + "img/ma.60fbc221.svg";